import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_SLIDER_CONTENT_SNIPPET = gql`
  mutation createContentSnippet(
    $containerId: Int!
    $visible: Boolean!
    $sliderId: Int!
  ) {
    contentSnippet {
      createContentSnippet(
        baseSnippet: { containerId: $containerId, visible: $visible }
        contentSnippetSlider: { sliderId: $sliderId }
      ) {
        id
        sort
      }
    }
  }
`;

const createSliderContentSnippetRequest = ({
  containerId,
  isVisible,
  sliderId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_SLIDER_CONTENT_SNIPPET}>
    {(createContentSnippet, { loading, error, data }) => {
      const variables = {
        containerId,
        visible: isVisible,
        sliderId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.contentSnippet.createContentSnippet.id,
          data.contentSnippet.createContentSnippet.sort
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentSnippet}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createSliderContentSnippetRequest.propTypes = {
  containerId: PropTypes.number.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  sliderId: PropTypes.number.isRequired,
};

createSliderContentSnippetRequest.defaultProps = {};

export default createSliderContentSnippetRequest;
